import React, {Component} from 'react';
import '../../Compact.css';

let _this;

class SigmaSpeaksCompact extends Component {

    constructor(props, context) {
        super(props);
        _this = this;
    }

    render() {
        return <div className="product-card">
            <div className="product-card-content">
                <div className="product-info">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}}
                             className="roundrect"
                             src="/sigma_speaks_artwork.png"
                             align="left"
                             alt="app icon"
                             width="128"/>
                        <div>
                            <h2>Sigma Speaks: Audio News Daily</h2>
                            <h3>Tailored for Retail Investors</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <div className="divider"></div>
                    <br/>
                    <div style={{margin: '0 24px 0 24px'}}>
                        <h4>LISTEN ON YOUR IPHONE OR ANDROID (Beta access)</h4>
                    </div>

                    <div className="product-links" style={{margin: '16px 0 0 16px'}}>
                        <a href="https://testflight.apple.com/join/kzNZGq4A"
                           target="_blank"
                           rel="noopener">
                            <img src="/app_store.png" alt="itunes" height="36" hspace="5" vspace="5"/>
                        </a>
                        <a href="https://play.google.com/apps/testing/com.answersolutions.sigmaspeak"
                           target="_blank"
                           rel="noopener">
                            <img src="/google_play.svg" alt="google play" height="36" hspace="5" vspace="5"/>
                        </a>
                    </div>
                    <div className="divider"></div>
                    <br/>
                    <div style={{margin: '0 24px 0 24px'}}>
                        <h4>Listen on Spotify and Apple Podcast</h4>
                    </div>
                    <div className="product-links" style={{margin: '16px 0 0 16px'}}>
                        <a href="https://open.spotify.com/show/7hz2cM5DfbbTv26ppMbfdR?si=7a50597451e14345"
                           target="_blank"
                           rel="noopener">
                            <img src="/spotify-podcast.png" alt="listen on spotify" height="36" hspace="5" vspace="5"/>
                        </a>
                        <a href="https://podcasts.apple.com/us/podcast/sigma-speaks/id1851266467"
                           target="_blank"
                           rel="noopener">
                            <img src="/apple_podcasts_b.svg" alt="listen on apple podcast" height="36" hspace="5" vspace="5"/>
                        </a>
                    </div>
                    <div className="divider"></div>
                    <div className="product-footer">
                        <div/>
                        <a href="#sigma-speaks-product"
                           role="button"
                           className="learn-more-button"
                           onClick={() => _this.props.navigate('SigmaSpeaksProduct')}
                        >Learn More →</a>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default SigmaSpeaksCompact;